import React from "react";
import ConfirmationPopUpModalComponent from "../../components/Std/ConfirmationPopUpModal/ConfirmationPopUpModalComponent";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";

const ConfirmationModalPopup = (props) => {
  const dispatch = useDispatch();
  const modalAction = bindActionCreators(modalActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  return (
    <ConfirmationPopUpModalComponent
      closeRemoveModal={closeRemoveModal}
      {...props}
    />
  );
};
export default ConfirmationModalPopup;
